"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MiniProviderBookAndReferCard_1 = require("../MiniProviderBookAndReferCard");
const MiniProviderBookAndReferList_styles_1 = require("./MiniProviderBookAndReferList.styles");
const MIN_ITEM_WIDTH = 200;
const MAX_ELEMENTS = 10;
/**
 * A component for rendering a list of small, interactive provider cards.
 */
const MiniProviderBookAndReferList = react_1.default.forwardRef((_a, ref) => {
    var { id, maxElements = MAX_ELEMENTS, showEmpty = MAX_ELEMENTS, minItemWidth = MIN_ITEM_WIDTH, showCount = true, showMoreThanMax = false, providers = [], hideFields, track, onRemoveReferral } = _a, rest = __rest(_a, ["id", "maxElements", "showEmpty", "minItemWidth", "showCount", "showMoreThanMax", "providers", "hideFields", "track", "onRemoveReferral"]);
    return (react_1.default.createElement(MiniProviderBookAndReferList_styles_1.ProviderCardList, Object.assign({ id: id, maxElements: maxElements, showEmpty: showEmpty, minItemWidth: minItemWidth, showCount: showCount, showMoreThanMax: showMoreThanMax }, rest, { ref: ref }), providers.map((detailedProvider) => {
        var _a;
        const key = `${detailedProvider.provider.id}-${(_a = detailedProvider.location) === null || _a === void 0 ? void 0 : _a.id}`;
        return (react_1.default.createElement(MiniProviderBookAndReferCard_1.MiniProviderBookAndReferCard, Object.assign({ key: key }, detailedProvider, { hideFields: hideFields, track: track, onRemoveReferral: onRemoveReferral })));
    })));
});
MiniProviderBookAndReferList.displayName = 'MiniProviderBookAndReferList';
exports.default = MiniProviderBookAndReferList;
//# sourceMappingURL=MiniProviderBookAndReferList.js.map